import { app } from './app';
import Translation from 'libs/Translation';
 
export const seo = {
	additionalMetaTags: [
		app.uat === false ? { name: 'robots', content: 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1' } : { name: 'robots', content: 'noindex, nofollow, max-image-preview:large, max-snippet:-1, max-video-preview:-1' },
		{ name: 'viewport', content: 'width=device-width, user-scalable=no, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0' },
		{ name: 'apple-mobile-web-app-status-bar-style', content: 'black' },
		{ name: 'theme-color', content: '#FFF' },
	],
	noindex: app.uat === false ? false : true,
	nofollow: app.uat === false ? false : true,
	openGraph: {
		type: 'website',
		images: [
			{
				url: '/nextasset/images/icons/logo.png',
				type: 'image/png',
				alt: Translation.t('title.default'),
			},
		],
	},
	twitter: {
		site: '@vclinic4',
		creator: '@vclinic4',
		card: 'summary',
	},
};
